import { useMutation, useQuery, useQueryClient } from "react-query"
import { createTenantLocation, getTenantLocationsData, updateTenantLocation } from "./tenantLocationsApi"
import { notification } from "antd"
import { CreateUpdateTenantLocationRequest } from "./tenantLocation"

export const useTenantLocationsDataQuery = () => {
  return useQuery(['tenantLocations'], () => getTenantLocationsData())
}

export const useCreateTenantLocationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((request: CreateUpdateTenantLocationRequest) => createTenantLocation(request), {
    onSuccess: () => {
      queryClient.invalidateQueries(['tenantLocations'])
    },
    onError: () => {
      notification.error({
        message: 'There was a problem creating the tenant location.'
      })
    }
  })
}

export const useUpdateTenantLocationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation(({ id, request }: { id: number, request: CreateUpdateTenantLocationRequest }) => updateTenantLocation(id, request), {
    onSuccess: () => {
      queryClient.invalidateQueries(['tenantLocations'])
    },
    onError: () => {
      notification.error({
        message: 'There was a problem updating the tenant location.'
      })
    }
  })
}